import styled from 'styled-components';
import UserLogoIcon from 'js/components/core/Icons/UserLogoIcon';

export default styled(UserLogoIcon)`
  display: block;
  width: 48px;
  margin: 0 auto;
  margin-bottom: 1rem;
`;
